import { ERROR_FOR_REMOTE } from '@shared/libs/errors-consts';
import { ErrorLayout } from '@shared/layouts/ErrorLayout';
import { FC } from 'react';

export const ErrorPageForRemote: FC = () => {
  return <ErrorLayout error={ERROR_FOR_REMOTE} showBasicButton={false} />;
};
